import { Routes, Route, Navigate } from 'react-router-dom';
import { DashboardPage } from '@/pages/dashboard';
import { ProjectsPage } from '@/pages/projects';
import { ProjectDetailsPage } from '@/pages/project-details';
import { PortfolioPage } from '@/pages/portfolio';
import { UtilisationPage } from '@/pages/utilisation';
import { WIPReportingPage } from '@/pages/wip-reporting';
import { ProfitabilityPage } from '@/pages/profitability';
import { BudgetsPage } from '@/pages/budgets';
import { ResourcesPage } from '@/pages/resources';
import { DirectoryPage } from '@/pages/directory';
import { RolesRatesPage } from '@/pages/roles-rates';
import { GanttPage } from '@/pages/gantt';
import { ProjectTransactionsPage } from '@/pages/project-transactions';
import { SettingsPage } from '@/pages/settings-hub';
import SettingsGeneral from '@/pages/settings-general';
import SettingsProject from '@/pages/settings-project';
import SettingsUserPreferences from '@/pages/settings-user-preferences';
import SettingsIntegrationsPage from '@/pages/settings-integrations';
import SettingsFeatureLabsPage from '@/pages/settings-feature-labs';
import SettingsUserPermissionsPage from '@/pages/settings-user-permissions';
import ProjectTemplatesPage from '@/pages/project-templates';
import SettingsTemplates from '@/pages/settings/settings-templates';

import { UserPreferencesPage } from '@/pages/user-preferences';
import CategoryManagement from '@/pages/category-management';
import { ProjectCreationSetup } from '@/pages/project-creation-setup';
import { ErrorHandlingDemoPage } from '@/pages/error-handling-demo';
import { ColumnConfiguratorDemo } from '@/pages/column-configurator-demo';
import { ResponsiveTableDemo } from '@/pages/responsive-table-demo';
import { DataTableDemo } from '@/pages/data-table-demo';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/projects" element={<ProjectsPage />} />
      <Route path="/projects/:projectId" element={<ProjectDetailsPage />} />
      <Route path="/portfolio" element={<PortfolioPage />} />
      <Route path="/utilisation" element={<UtilisationPage />} />
      <Route path="/wip-reporting" element={<WIPReportingPage />} />
      <Route path="/profitability" element={<ProfitabilityPage />} />
      <Route path="/budgets" element={<BudgetsPage />} />
      <Route path="/resources" element={<ResourcesPage />} />
      <Route path="/directory" element={<DirectoryPage />} />
      <Route path="/roles-rates" element={<RolesRatesPage />} />
      <Route path="/gantt" element={<GanttPage />} />
      <Route path="/project-transactions" element={<ProjectTransactionsPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/settings/general" element={<SettingsGeneral />} />
      <Route path="/settings/project" element={<SettingsProject />} />
      <Route path="/settings/user-preferences" element={<SettingsUserPreferences />} />
      <Route path="/settings/integrations" element={<SettingsIntegrationsPage />} />
      <Route path="/settings/feature-labs" element={<SettingsFeatureLabsPage />} />
      <Route path="/settings/user-permissions" element={<SettingsUserPermissionsPage />} />
      <Route path="/settings/templates" element={<SettingsTemplates />} />
      <Route path="/project-templates" element={<ProjectTemplatesPage />} />
      <Route path="/user-preferences" element={<UserPreferencesPage />} />
      <Route path="/category-management" element={<CategoryManagement />} />
      <Route path="/project-creation-setup" element={<ProjectCreationSetup />} />
      <Route path="/error-handling-demo" element={<ErrorHandlingDemoPage />} />
      <Route path="/column-configurator-demo" element={<ColumnConfiguratorDemo />} />
      <Route path="/responsive-table-demo" element={<ResponsiveTableDemo />} />
      <Route path="/data-table-demo" element={<DataTableDemo />} />
      {/* Catch all - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

// Route path constants for easy reference
export const ROUTES = {
  DASHBOARD: '/dashboard',
  PROJECTS: '/projects',
  PROJECT_DETAILS: (projectId: number) => `/projects/${projectId}`,
  PORTFOLIO: '/portfolio',
  UTILISATION: '/utilisation',
  WIP_REPORTING: '/wip-reporting',
  PROFITABILITY: '/profitability',
  BUDGETS: '/budgets',
  RESOURCES: '/resources',
  DIRECTORY: '/directory',
  ROLES_RATES: '/roles-rates',
  GANTT: '/gantt',
  PROJECT_TRANSACTIONS: '/project-transactions',
  SETTINGS: '/settings',
  SETTINGS_GENERAL: '/settings/general',
  SETTINGS_PROJECT: '/settings/project',
  SETTINGS_USER_PREFERENCES: '/settings/user-preferences',
  SETTINGS_INTEGRATIONS: '/settings/integrations',
  SETTINGS_FEATURE_LABS: '/settings/feature-labs',
  SETTINGS_USER_PERMISSIONS: '/settings/user-permissions',
  SETTINGS_TEMPLATES: '/settings/templates',
  PROJECT_TEMPLATES: '/project-templates',
  USER_PREFERENCES: '/user-preferences',
  CATEGORY_MANAGEMENT: '/category-management',
  PROJECT_CREATION_SETUP: '/project-creation-setup',
  ERROR_HANDLING_DEMO: '/error-handling-demo',
  COLUMN_CONFIGURATOR_DEMO: '/column-configurator-demo',
  RESPONSIVE_TABLE_DEMO: '/responsive-table-demo',
  DATA_TABLE_DEMO: '/data-table-demo',
} as const;
